// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.wrapper-table {
  overflow: visible !important;
}
.wrapper-table .ant-table {
  border-radius: 4px !important;
  overflow: visible !important;
  background-color: transparent !important;
}
.wrapper-table .ant-table .ant-table-thead > tr > th {
  background-color: var(--color-bg-muted) !important;
  color: var(--color-text) !important;
  height: 40px;
  padding: 8px;
  line-height: 1.2;
  font-size: 16px;
  font-weight: var(--fw-semibold);
  border-bottom: 1px solid var(--color-border) !important;
}
.wrapper-table .ant-table .ant-table-thead > tr > th:hover {
  background-color: var(--color-bg-emphasis) !important;
}
.wrapper-table .ant-table .ant-table-thead > tr > th.ant-table-column-sort, .wrapper-table .ant-table .ant-table-thead > tr > th.ant-table-column-has-sorters {
  border-left: none !important;
  border-right: none !important;
}
.wrapper-table .ant-table .ant-table-thead > tr > th.ant-table-column-sort::before, .wrapper-table .ant-table .ant-table-thead > tr > th.ant-table-column-has-sorters::before {
  background-color: transparent !important;
}
.wrapper-table .ant-table .ant-table-thead th.ant-table-column-sort,
.wrapper-table .ant-table .ant-table-thead th.ant-table-column-has-sorters {
  background-color: var(--color-bg-muted) !important;
}
.wrapper-table .ant-table .ant-table-thead th.ant-table-column-sort:hover,
.wrapper-table .ant-table .ant-table-thead th.ant-table-column-has-sorters:hover {
  background-color: var(--color-bg-emphasis) !important;
}
.wrapper-table .ant-table .ant-table-tbody > tr {
  background-color: var(--color-bg) !important;
  color: var(--color-text) !important;
}
.wrapper-table .ant-table .ant-table-tbody > tr > td {
  color: var(--color-text) !important;
}
.wrapper-table .ant-table .ant-table-tbody > tr.ant-table-row-selected > td {
  background-color: var(--color-primary-soft) !important;
}
.wrapper-table .ant-table .ant-table-tbody > tr:hover > td, .wrapper-table .ant-table .ant-table-tbody > tr.ant-table-row-hover > td,
.wrapper-table .ant-table .ant-table-tbody > tr > td.ant-table-cell-row-hover {
  background-color: var(--color-bg-emphasis) !important;
  color: var(--color-text) !important;
}
.wrapper-table .ant-table .ant-table-tbody > tr:hover .hover-visible {
  opacity: 1;
}
.wrapper-table .ant-table .ant-table-tbody > tr > td:last-child {
  padding: 8px !important;
  text-align: center;
}
.wrapper-table .ant-table .ant-table-tbody > tr > td[align=right] {
  padding-right: 8px !important;
}
.wrapper-table .ant-table .ant-table-tbody > tr > td {
  font-size: 15px;
}
.wrapper-table .ant-table .ant-table-column-sorter-inner {
  color: var(--color-text-subtle) !important;
}
.wrapper-table .ant-table .ant-table-thead > tr > th.ant-table-selection-column {
  background-color: var(--color-bg-muted) !important;
}
.wrapper-table .ant-table-pagination {
  display: flex !important;
  justify-content: center !important;
  width: 100% !important;
  margin-top: 16px !important;
}
.wrapper-table .ant-table-pagination .ant-pagination-item {
  background-color: var(--color-bg) !important;
  border-color: var(--color-border) !important;
}
.wrapper-table .ant-table-pagination .ant-pagination-item a {
  color: var(--color-text) !important;
}
.wrapper-table .ant-table-pagination .ant-pagination-item:hover {
  border-color: var(--color-primary) !important;
}
.wrapper-table .ant-table-pagination .ant-pagination-item:hover a {
  color: var(--color-primary) !important;
}
.wrapper-table .ant-table-pagination .ant-pagination-item-active {
  background-color: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
}
.wrapper-table .ant-table-pagination .ant-pagination-item-active a {
  color: var(--color-text-inverse) !important;
}
.wrapper-table .ant-table-pagination .ant-pagination-item-active:hover a {
  color: var(--color-text-inverse) !important;
}
.wrapper-table .ant-table-pagination .ant-pagination-prev .ant-pagination-item-link,
.wrapper-table .ant-table-pagination .ant-pagination-next .ant-pagination-item-link,
.wrapper-table .ant-table-pagination .ant-pagination-jump-prev .ant-pagination-item-link,
.wrapper-table .ant-table-pagination .ant-pagination-jump-next .ant-pagination-item-link {
  background-color: var(--color-bg) !important;
  border-color: var(--color-border) !important;
  color: var(--color-text) !important;
}
.wrapper-table .ant-table-pagination .ant-pagination-prev:hover .ant-pagination-item-link,
.wrapper-table .ant-table-pagination .ant-pagination-next:hover .ant-pagination-item-link,
.wrapper-table .ant-table-pagination .ant-pagination-jump-prev:hover .ant-pagination-item-link,
.wrapper-table .ant-table-pagination .ant-pagination-jump-next:hover .ant-pagination-item-link {
  border-color: var(--color-primary) !important;
  color: var(--color-primary) !important;
}
.wrapper-table .ant-table-pagination .ant-pagination-item-ellipsis,
.wrapper-table .ant-table-pagination .ant-pagination-item-link-icon {
  color: var(--color-text-muted) !important;
}
.wrapper-table .ant-table-pagination .ant-pagination-disabled .ant-pagination-item-link {
  color: var(--color-text-disabled) !important;
  border-color: var(--color-border) !important;
}
.wrapper-table table thead th {
  text-align: center !important;
}
.wrapper-table .ant-table-tbody > tr {
  cursor: pointer; /* 전체 행에 포인터 커서 적용 */
  /* 모든 셀에 포인터 커서 적용 */
}
.wrapper-table .ant-table-tbody > tr td {
  cursor: pointer;
}

.stability-table {
  padding: 4px 8px;
  border-radius: 4px;
  text-align: center;
  width: 80%;
  height: 30px;
  position: relative;
  isolation: isolate;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stability-table::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: inherit;
  z-index: -1;
}

.text-input-change {
  border: 1px solid #a6a6a6;
  border-radius: 3px;
  height: 30px;
  padding: 2px 4px;
  font-size: inherit;
  line-height: inherit;
  box-sizing: border-box;
  width: 100%;
}

.modal-report-name {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: var(--color-surface-overlay);
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  max-width: 300px;
  max-height: 300px;
  overflow-y: auto;
  color: var(--color-text);
  /* 팝업이 테이블 영역을 벗어나도 보이도록 설정 */
  overflow: visible;
}

/* 팝업 컨테이너 스타일 */
.host-cell {
  position: relative;
}
.host-cell .host-name-view {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.host-cell .host-name-view .host-name-text {
  cursor: pointer;
  transition: color 0.2s;
}
.host-cell .host-name-view .host-name-text:hover {
  color: var(--color-primary-hover);
  text-decoration: underline;
}
.host-cell .host-name-view .host-download-button {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
  color: #a6a6a6;
  padding: 0;
  margin-left: 4px;
}
.host-cell .host-name-view .host-download-button:hover {
  color: var(--color-primary-hover);
}

/* 팝업 내용 스타일 */
.modal-report-name__text {
  padding: 5px;
  border-radius: 3px;
  transition: background-color 0.2s;
}
.modal-report-name__text:hover {
  background-color: #f0f0f0;
}

/* 테이블 컨테이너에 오버플로우 설정 */
.wrapper-table {
  position: relative;
  overflow: visible !important;
}
.wrapper-table .ant-table-wrapper {
  overflow: visible !important;
}
.wrapper-table .ant-table-wrapper .ant-table {
  overflow: visible !important;
}
.wrapper-table .ant-table-wrapper .ant-table .ant-table-container {
  overflow: visible !important;
}
.wrapper-table .ant-table-wrapper .ant-table .ant-table-container .ant-table-content {
  overflow: visible !important;
}
.wrapper-table .ant-table-wrapper .ant-table .ant-table-container .ant-table-content table {
  overflow: visible !important;
}

.color-black {
  color: black;
}

.report-name-cell {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 100%;
}
.report-name-cell .report-name-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.report-name-cell .report-name-view .report-name-group {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1 1;
}
.report-name-cell .report-name-view .report-name-text {
  cursor: pointer;
}
.report-name-cell .report-name-view .report-name-text:hover {
  text-decoration: underline;
}
.report-name-cell .report-name-view .new-window-button {
  color: #a6a6a6;
  cursor: pointer;
  font-size: 16px;
  opacity: 0;
  transition: opacity 0.2s;
}
.report-name-cell .report-name-view .new-window-button:hover {
  color: var(--color-primary-hover);
}
.report-name-cell .report-name-view .report-edit-button {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  color: #a6a6a6;
  padding: 0;
  margin-left: 4px;
}
.report-name-cell .report-name-view .report-edit-button:hover {
  color: var(--color-primary-hover);
}

.ant-table-tbody > tr:hover .report-name-cell .report-edit-button,
.ant-table-tbody > tr:hover .report-name-cell .new-window-button,
.ant-table-tbody > tr:hover .host-cell .host-download-button {
  visibility: visible;
  opacity: 1;
}

.history-tooltip .ant-tooltip-inner {
  background-color: var(--color-surface-dark) !important;
  color: var(--color-text-on-dark) !important;
  font-size: 12px !important;
  padding: 6px 12px !important;
  border-radius: var(--radius-md) !important;
  box-shadow: var(--shadow-md) !important;
  max-width: 250px !important;
  min-height: 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1.3 !important;
  font-weight: var(--fw-medium);
}
.history-tooltip .ant-tooltip-arrow::before,
.history-tooltip .ant-tooltip-arrow::after,
.history-tooltip .ant-tooltip-arrow-content,
.history-tooltip .ant-tooltip-arrow-inner {
  background-color: var(--color-surface-dark) !important;
}

[data-theme=dark] .history-tooltip .ant-tooltip-inner {
  background-color: var(--color-surface-dark-2) !important;
  border: 1px solid rgba(148, 163, 184, 0.2);
}
[data-theme=dark] .history-tooltip .ant-tooltip-arrow::before,
[data-theme=dark] .history-tooltip .ant-tooltip-arrow::after,
[data-theme=dark] .history-tooltip .ant-tooltip-arrow-content,
[data-theme=dark] .history-tooltip .ant-tooltip-arrow-inner {
  background-color: var(--color-surface-dark-2) !important;
}

.stability-progress-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
  padding: 0;
  margin: -8px 0;
}

.stability-progress-bar {
  width: 100%;
  height: 30px;
  background-color: transparent;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  box-shadow: none;
}
.stability-progress-bar .stability-progress-fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 4px;
  z-index: 1;
}

.ant-table-tbody > tr > td {
  padding: 8px 16px !important;
  border-bottom-color: var(--color-border) !important;
}

.ant-table-tbody > tr > td:nth-child(8) {
  padding: 0 !important;
}

.ant-table-tbody > tr:hover .stability-progress-bar {
  background-color: var(--color-bg-emphasis) !important;
}

.ant-table-tbody > tr:hover .stability-progress-fill {
  background-color: inherit !important;
}

.stability-progress-text-inside {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 500;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.7);
  z-index: 2;
  width: 100%;
  pointer-events: none;
}

.host-cell .host-name-view {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.host-cell .host-name-view .host-name-text {
  cursor: pointer;
  transition: color 0.2s;
}
.host-cell .host-name-view .host-name-text:hover {
  color: var(--color-primary-hover);
  text-decoration: underline;
}
.host-cell .host-name-view .host-download-button {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
  color: #a6a6a6;
  padding: 0;
  margin-left: 4px;
}
.host-cell .host-name-view .host-download-button:hover {
  color: var(--color-primary-hover);
}

.ant-table-tbody > tr:hover .host-download-button {
  visibility: visible;
  opacity: 1;
}

.report-name-text {
  text-decoration: none !important;
}
.report-name-text:hover {
  text-decoration: none !important;
  border-bottom: none !important;
}

/* 포털 팝업 스타일 */
.host-popup-portal {
  color: #333;
  font-size: 14px;
}
.host-popup-portal .host-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
  font-weight: 500;
}
.host-popup-portal .host-popup-item:hover {
  background-color: #f5f5f5;
}

/* 기존 팝업 스타일은 유지 */
.host-cell .host-name-view {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.host-cell .host-name-view .host-name-text {
  cursor: pointer;
  transition: color 0.2s;
}
.host-cell .host-name-view .host-name-text:hover {
  color: var(--color-primary-hover);
  text-decoration: underline;
}
.host-cell .host-name-view .host-download-button {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
  color: #a6a6a6;
  padding: 0;
  margin-left: 4px;
}
.host-cell .host-name-view .host-download-button:hover {
  color: var(--color-primary-hover);
}`, "",{"version":3,"sources":["webpack://./src/pages/History/component/table/TableHistory.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,4BAAA;AAEF;AADE;EACE,6BAAA;EACA,4BAAA;EAIA,wCAAA;AAAJ;AAGM;EACE,kDAAA;EACA,mCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,uDAAA;AADR;AAGQ;EACE,qDAAA;AADV;AAIQ;EAEE,4BAAA;EACA,6BAAA;AAHV;AAKU;EACE,wCAAA;AAHZ;AAQM;;EAEE,kDAAA;AANR;AAQQ;;EACE,qDAAA;AALV;AAWM;EAEE,4CAAA;EACA,mCAAA;AAVR;AAaQ;EACE,mCAAA;AAXV;AAeQ;EACE,sDAAA;AAbV;AAkBQ;;EAGE,qDAAA;EACA,mCAAA;AAjBV;AAqBQ;EACE,UAAA;AAnBV;AAsBQ;EACE,uBAAA;EACA,kBAAA;AApBV;AAuBQ;EACE,6BAAA;AArBV;AAwBQ;EACE,eAAA;AAtBV;AA2BI;EACE,0CAAA;AAzBN;AA8BM;EACE,kDAAA;AA5BR;AAiCE;EACE,wBAAA;EACA,kCAAA;EACA,sBAAA;EACA,2BAAA;AA/BJ;AAoCI;EACE,4CAAA;EACA,4CAAA;AAlCN;AAoCM;EACE,mCAAA;AAlCR;AAqCM;EACE,6CAAA;AAnCR;AAqCQ;EACE,sCAAA;AAnCV;AAuCM;EACE,iDAAA;EACA,6CAAA;AArCR;AAuCQ;EACE,2CAAA;AArCV;AAwCQ;EACE,2CAAA;AAtCV;AA+CM;;;;EACE,4CAAA;EACA,4CAAA;EACA,mCAAA;AA1CR;AA6CM;;;;EACE,6CAAA;EACA,sCAAA;AAxCR;AA4CI;;EAEE,yCAAA;AA1CN;AA6CI;EACE,4CAAA;EACA,4CAAA;AA3CN;AA+CE;EACE,6BAAA;AA7CJ;AAgDE;EACE,eAAA,EAAA,oBAAA;EAEA,oBAAA;AA/CJ;AAgDI;EACE,eAAA;AA9CN;;AAmDA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhDF;AAkDE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAhDJ;;AAoDA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,WAAA;AAjDF;;AAoDA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EAGA,8CAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EAEA,6BAAA;EACA,iBAAA;AApDF;;AAuDA,gBAAA;AACA;EACE,kBAAA;AApDF;AAsDE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AApDJ;AAsDI;EACE,eAAA;EACA,sBAAA;AApDN;AAsDM;EACE,iCAAA;EACA,0BAAA;AApDR;AAwDI;EACE,kBAAA;EACA,UAAA;EACA,iEAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAtDN;AAwDM;EACE,iCAAA;AAtDR;;AA4DA,cAAA;AACA;EACE,YAAA;EACA,kBAAA;EACA,iCAAA;AAzDF;AA2DE;EACE,yBAAA;AAzDJ;;AA6DA,uBAAA;AACA;EACE,kBAAA;EACA,4BAAA;AA1DF;AA4DE;EACE,4BAAA;AA1DJ;AA4DI;EACE,4BAAA;AA1DN;AA4DM;EACE,4BAAA;AA1DR;AA4DQ;EACE,4BAAA;AA1DV;AA4DU;EACE,4BAAA;AA1DZ;;AAkEA;EACE,YAAA;AA/DF;;AAkEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AA/DF;AAiEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AA/DJ;AAiEI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;AA/DN;AAkEI;EACE,eAAA;AAhEN;AAkEM;EACE,0BAAA;AAhER;AAoEI;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,wBAAA;AAlEN;AAoEM;EACE,iCAAA;AAlER;AAsEI;EACE,kBAAA;EACA,UAAA;EACA,oCAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AApEN;AAsEM;EACE,iCAAA;AApER;;AA4EE;;;EAGE,mBAAA;EACA,UAAA;AAzEJ;;AAiFE;EACE,sDAAA;EACA,2CAAA;EACA,0BAAA;EACA,4BAAA;EACA,0CAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,2BAAA;EACA,6BAAA;AA9EJ;AAiFE;;;;EAIE,sDAAA;AA/EJ;;AAsFE;EACE,wDAAA;EACA,0CAAA;AAnFJ;AAsFE;;;;EAIE,wDAAA;AApFJ;;AAyFA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;AAtFF;;AAyFA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAtFF;AAwFE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;AAtFJ;;AA2FA;EACE,4BAAA;EAGA,mDAAA;AA1FF;;AA8FA;EACE,qBAAA;AA3FF;;AA+FA;EACE,qDAAA;AA5FF;;AAgGA;EACE,oCAAA;AA7FF;;AAiGA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,uCAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;AA9FF;;AAmGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAhGJ;AAkGI;EACE,eAAA;EACA,sBAAA;AAhGN;AAkGM;EACE,iCAAA;EACA,0BAAA;AAhGR;AAoGI;EACE,kBAAA;EACA,UAAA;EACA,iEAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAlGN;AAoGM;EACE,iCAAA;AAlGR;;AAyGA;EACE,mBAAA;EACA,UAAA;AAtGF;;AA0GA;EACE,gCAAA;AAvGF;AAyGE;EACE,gCAAA;EACA,8BAAA;AAvGJ;;AA2GA,cAAA;AACA;EACE,WAAA;EACA,eAAA;AAxGF;AA0GE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;AAxGJ;AA4GI;EACE,yBAAA;AA1GN;;AA+GA,kBAAA;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AA7GJ;AA+GI;EACE,eAAA;EACA,sBAAA;AA7GN;AA+GM;EACE,iCAAA;EACA,0BAAA;AA7GR;AAiHI;EACE,kBAAA;EACA,UAAA;EACA,iEAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AA/GN;AAiHM;EACE,iCAAA;AA/GR","sourcesContent":[".wrapper-table {\n  overflow: visible !important;\n  .ant-table {\n    border-radius: 4px !important;\n    overflow: visible !important;\n    // antd's default white .ant-table background leaks through the 4px rounded\n    // corners against a dark page bg (visible white slivers in dark mode). Make\n    // the table itself transparent so corners blend into the page surface.\n    background-color: transparent !important;\n\n    .ant-table-thead {\n      > tr > th {\n        background-color: var(--color-bg-muted) !important;\n        color: var(--color-text) !important;\n        height: 40px;\n        padding: 8px;\n        line-height: 1.2;\n        font-size: 16px;\n        font-weight: var(--fw-semibold);\n        border-bottom: 1px solid var(--color-border) !important;\n\n        &:hover {\n          background-color: var(--color-bg-emphasis) !important;\n        }\n\n        &.ant-table-column-sort,\n        &.ant-table-column-has-sorters {\n          border-left: none !important;\n          border-right: none !important;\n\n          &::before {\n            background-color: transparent !important;\n          }\n        }\n      }\n\n      th.ant-table-column-sort,\n      th.ant-table-column-has-sorters {\n        background-color: var(--color-bg-muted) !important;\n\n        &:hover {\n          background-color: var(--color-bg-emphasis) !important;\n        }\n      }\n    }\n\n    .ant-table-tbody {\n      > tr {\n        // 기본 배경색 — 토큰화로 라이트/다크 자동 전환\n        background-color: var(--color-bg) !important;\n        color: var(--color-text) !important;\n\n        // 셀 텍스트 색도 토큰화 (다크모드에서 행 위 글자 대비 확보)\n        > td {\n          color: var(--color-text) !important;\n        }\n\n        // 체크박스로 선택된 행 — 토큰화된 옅은 sky 톤 (모드별 자동 전환)\n        &.ant-table-row-selected > td {\n          background-color: var(--color-primary-soft) !important;\n        }\n\n        // 모든 행의 호버 효과 — slate-200/700 토널 시프트로 글자 대비 확보.\n        // primary-soft(다크에서 16% 알파) 위에 흰 글자는 잘 안 보였음.\n        &:hover > td,\n        &.ant-table-row-hover > td,\n        > td.ant-table-cell-row-hover {\n          background-color: var(--color-bg-emphasis) !important;\n          color: var(--color-text) !important;\n        }\n\n        // 행에 호버했을 때 연필 아이콘 표시\n        &:hover .hover-visible {\n          opacity: 1;\n        }\n\n        > td:last-child {\n          padding: 8px !important;\n          text-align: center;\n        }\n\n        > td[align=\"right\"] {\n          padding-right: 8px !important;\n        }\n\n        > td {\n          font-size: 15px;\n        }\n      }\n    }\n\n    .ant-table-column-sorter-inner {\n      color: var(--color-text-subtle) !important;\n    }\n\n    // 헤더의 체크박스 컬럼 (헤더와 동일 라이트 톤)\n    .ant-table-thead {\n      > tr > th.ant-table-selection-column {\n        background-color: var(--color-bg-muted) !important;\n      }\n    }\n  }\n\n  .ant-table-pagination {\n    display: flex !important;\n    justify-content: center !important;\n    width: 100% !important;\n    margin-top: 16px !important;\n\n    // Pagination number buttons — antd defaults use #fff bg + dark text, which\n    // disappears on the slate-900 page background in dark mode. Tokenize so\n    // both modes render readable page numbers, prev/next arrows, and ellipsis.\n    .ant-pagination-item {\n      background-color: var(--color-bg) !important;\n      border-color: var(--color-border) !important;\n\n      a {\n        color: var(--color-text) !important;\n      }\n\n      &:hover {\n        border-color: var(--color-primary) !important;\n\n        a {\n          color: var(--color-primary) !important;\n        }\n      }\n\n      &-active {\n        background-color: var(--color-primary) !important;\n        border-color: var(--color-primary) !important;\n\n        a {\n          color: var(--color-text-inverse) !important;\n        }\n\n        &:hover a {\n          color: var(--color-text-inverse) !important;\n        }\n      }\n    }\n\n    .ant-pagination-prev,\n    .ant-pagination-next,\n    .ant-pagination-jump-prev,\n    .ant-pagination-jump-next {\n      .ant-pagination-item-link {\n        background-color: var(--color-bg) !important;\n        border-color: var(--color-border) !important;\n        color: var(--color-text) !important;\n      }\n\n      &:hover .ant-pagination-item-link {\n        border-color: var(--color-primary) !important;\n        color: var(--color-primary) !important;\n      }\n    }\n\n    .ant-pagination-item-ellipsis,\n    .ant-pagination-item-link-icon {\n      color: var(--color-text-muted) !important;\n    }\n\n    .ant-pagination-disabled .ant-pagination-item-link {\n      color: var(--color-text-disabled) !important;\n      border-color: var(--color-border) !important;\n    }\n  }\n\n  table thead th {\n    text-align: center !important;\n  }\n\n  .ant-table-tbody > tr {\n    cursor: pointer; /* 전체 행에 포인터 커서 적용 */\n    \n    /* 모든 셀에 포인터 커서 적용 */\n    td {\n      cursor: pointer;\n    }\n  }\n}\n  \n.stability-table {\n  padding: 4px 8px;\n  border-radius: 4px;\n  text-align: center;\n  width: 80%;\n  height: 30px;\n  position: relative;\n  isolation: isolate;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  &::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    border-radius: inherit;\n    background: inherit;\n    z-index: -1;\n  }\n}\n\n.text-input-change {\n  border: 1px solid #a6a6a6;\n  border-radius: 3px;\n  height: 30px;\n  padding: 2px 4px;\n  font-size: inherit;\n  line-height: inherit;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.modal-report-name {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  // 테이블 위에 뜨는 패널입니다. 라이트에서는 그대로 #FFFFFF 이고 다크에서만\n  // 어두운 표면으로 전환됩니다.\n  background-color: var(--color-surface-overlay);\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  padding: 10px;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  min-width: 200px;\n  max-width: 300px;\n  max-height: 300px;\n  overflow-y: auto;\n  color: var(--color-text);\n  \n  /* 팝업이 테이블 영역을 벗어나도 보이도록 설정 */\n  overflow: visible;\n}\n\n/* 팝업 컨테이너 스타일 */\n.host-cell {\n  position: relative;\n  \n  .host-name-view {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    \n    .host-name-text {\n      cursor: pointer;\n      transition: color 0.2s;\n      \n      &:hover {\n        color: var(--color-primary-hover);\n        text-decoration: underline;\n      }\n    }\n    \n    .host-download-button {\n      visibility: hidden;\n      opacity: 0;\n      transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;\n      color: #a6a6a6;\n      padding: 0;\n      margin-left: 4px;\n      \n      &:hover {\n        color: var(--color-primary-hover);\n      }\n    }\n  }\n}\n\n/* 팝업 내용 스타일 */\n.modal-report-name__text {\n  padding: 5px;\n  border-radius: 3px;\n  transition: background-color 0.2s;\n  \n  &:hover {\n    background-color: #f0f0f0;\n  }\n}\n\n/* 테이블 컨테이너에 오버플로우 설정 */\n.wrapper-table {\n  position: relative;\n  overflow: visible !important;\n  \n  .ant-table-wrapper {\n    overflow: visible !important;\n    \n    .ant-table {\n      overflow: visible !important;\n      \n      .ant-table-container {\n        overflow: visible !important;\n        \n        .ant-table-content {\n          overflow: visible !important;\n          \n          table {\n            overflow: visible !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n.color-black {\n  color: black;\n}\n\n.report-name-cell {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  \n  .report-name-view {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    \n    .report-name-group {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      flex: 1;\n    }\n    \n    .report-name-text {\n      cursor: pointer;\n      \n      &:hover {\n        text-decoration: underline;\n      }\n    }\n    \n    .new-window-button {\n      color: #a6a6a6;\n      cursor: pointer;\n      font-size: 16px;\n      opacity: 0;\n      transition: opacity 0.2s;\n      \n      &:hover {\n        color: var(--color-primary-hover);\n      }\n    }\n    \n    .report-edit-button {\n      visibility: hidden;\n      opacity: 0;\n      transition: opacity 0.2s ease-in-out;\n      color: #a6a6a6;\n      padding: 0;\n      margin-left: 4px;\n      \n      &:hover {\n        color: var(--color-primary-hover);\n      }\n    }\n  }\n}\n\n// 행에 마우스 호버 시 버튼 표시\n.ant-table-tbody > tr:hover {\n  .report-name-cell .report-edit-button,\n  .report-name-cell .new-window-button,\n  .host-cell .host-download-button {\n    visibility: visible;\n    opacity: 1;\n  }\n}\n\n// 툴팁 — 양쪽 모드 모두 어두운 슬레이트 톤 (클래식 floating dark tooltip 패턴).\n// 라이트=slate-900 (페이지 흰 배경 위 진한 팝), 다크=slate-800 elevated (슬레이트-900\n// 페이지와 한 단계 분리). 글자는 양쪽 다 밝은 슬레이트로 통일.\n.history-tooltip {\n  .ant-tooltip-inner {\n    background-color: var(--color-surface-dark) !important;\n    color: var(--color-text-on-dark) !important;\n    font-size: 12px !important;\n    padding: 6px 12px !important;\n    border-radius: var(--radius-md) !important;\n    box-shadow: var(--shadow-md) !important;\n    max-width: 250px !important;\n    min-height: 24px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    line-height: 1.3 !important;\n    font-weight: var(--fw-medium);\n  }\n\n  .ant-tooltip-arrow::before,\n  .ant-tooltip-arrow::after,\n  .ant-tooltip-arrow-content,\n  .ant-tooltip-arrow-inner {\n    background-color: var(--color-surface-dark) !important;\n  }\n}\n\n// 다크모드에선 페이지 자체가 slate-900이라 동색이면 안 보임 → slate-800로 한 단계\n// 띄우고 옅은 보더로 윤곽 확보.\n[data-theme=\"dark\"] .history-tooltip {\n  .ant-tooltip-inner {\n    background-color: var(--color-surface-dark-2) !important;\n    border: 1px solid rgba(148, 163, 184, 0.20);\n  }\n\n  .ant-tooltip-arrow::before,\n  .ant-tooltip-arrow::after,\n  .ant-tooltip-arrow-content,\n  .ant-tooltip-arrow-inner {\n    background-color: var(--color-surface-dark-2) !important;\n  }\n}\n\n// 안정성 그래프 관련 스타일 수정\n.stability-progress-wrapper {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  padding: 0;\n  margin: -8px 0; // 음수 마진으로 셀 패딩 상쇄\n}\n\n.stability-progress-bar {\n  width: 100%;\n  height: 30px;\n  background-color: transparent; // 배경색 투명하게 변경\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n  box-shadow: none; // 그림자 제거\n  \n  .stability-progress-fill {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    transition: width 0.3s ease;\n    border-radius: 4px;\n    z-index: 1; // 채워진 부분이 위에 오도록\n  }\n}\n\n// 테이블 셀 패딩 조정\n.ant-table-tbody > tr > td {\n  padding: 8px 16px !important;\n  // 행 구분선 — antd 기본 split이 다크에서 거의 흰색이라 흰 글자와 충돌.\n  // 토큰화로 라이트=slate-200, 다크=slate-700 옅은 구분선으로 톤 다운.\n  border-bottom-color: var(--color-border) !important;\n}\n\n// 안정성 컬럼 셀 패딩 특별 처리\n.ant-table-tbody > tr > td:nth-child(8) { // 안정성 컬럼이 8번째라고 가정\n  padding: 0 !important; // 패딩 제거\n}\n\n// 호버 시 안정성 컬럼 스타일 — 토큰화 (다크에서 흰 찌꺼기로 보이던 문제 수정).\n.ant-table-tbody > tr:hover .stability-progress-bar {\n  background-color: var(--color-bg-emphasis) !important;\n}\n\n// 호버 시 채워진 부분 스타일\n.ant-table-tbody > tr:hover .stability-progress-fill {\n  background-color: inherit !important; // 원래 그라데이션 유지\n}\n\n// 안정성 텍스트 스타일 유지\n.stability-progress-text-inside {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 500;\n  text-shadow: 0 0 2px rgba(0, 0, 0, 0.7);\n  z-index: 2;\n  width: 100%;\n  pointer-events: none;\n}\n\n// 호스트 셀 스타일 - 밑줄 유지\n.host-cell {\n  .host-name-view {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    \n    .host-name-text {\n      cursor: pointer;\n      transition: color 0.2s;\n      \n      &:hover {\n        color: var(--color-primary-hover);\n        text-decoration: underline;\n      }\n    }\n    \n    .host-download-button {\n      visibility: hidden;\n      opacity: 0;\n      transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;\n      color: #a6a6a6;\n      padding: 0;\n      margin-left: 4px;\n      \n      &:hover {\n        color: var(--color-primary-hover);\n      }\n    }\n  }\n}\n\n// 행에 마우스 호버 시 호스트 다운로드 아이콘 표시\n.ant-table-tbody > tr:hover .host-download-button {\n  visibility: visible;\n  opacity: 1;\n}\n\n// 리포트명 텍스트에만 밑줄 제거\n.report-name-text {\n  text-decoration: none !important;\n  \n  &:hover {\n    text-decoration: none !important;\n    border-bottom: none !important;\n  }\n}\n\n/* 포털 팝업 스타일 */\n.host-popup-portal {\n  color: #333;\n  font-size: 14px;\n  \n  .host-popup-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid #f0f0f0;\n    font-weight: 500;\n  }\n  \n  .host-popup-item {\n    &:hover {\n      background-color: #f5f5f5;\n    }\n  }\n}\n\n/* 기존 팝업 스타일은 유지 */\n.host-cell {\n  .host-name-view {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    \n    .host-name-text {\n      cursor: pointer;\n      transition: color 0.2s;\n      \n      &:hover {\n        color: var(--color-primary-hover);\n        text-decoration: underline;\n      }\n    }\n    \n    .host-download-button {\n      visibility: hidden;\n      opacity: 0;\n      transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;\n      color: #a6a6a6;\n      padding: 0;\n      margin-left: 4px;\n      \n      &:hover {\n        color: var(--color-primary-hover);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
